export enum AnalyticsEvent {
    //HelpMessage
    CREATED_HELP_MESSAGE = "CREATED_HELP_MESSAGE",
    ADDED_SESSION_URL_TO_HELP_MESSAGE = "ADDED_SESSION_URL_TO_HELP_MESSAGE",
    CREATED_HELP_MESSAGE_ATTACHMENT = "CREATED_HELP_MESSAGE_ATTACHMENT",
    DELETED_HELP_MESSAGE = "DELETED_HELP_MESSAGE",
    CREATED_HELP_CHAT = "CREATED_HELP_CHAT",
    DELETED_HELP_CHAT = "DELETED_HELP_CHAT",

    //Free Access
    ENABLED_FREE_ACCESS = "ENABLED_FREE_ACCESS",
    DISABLED_FREE_ACCESS = "DISABLED_FREE_ACCESS",
    ENABLE_FREE_ACCESS_ERROR = "ENABLE_FREE_ACCESS_ERROR",
    DISABLE_FREE_ACCESS_ERROR = "DISABLE_FREE_ACCESS_ERROR",
    GET_ORG_SUBSCRIPTIONS_ERROR = "GET_ORG_SUBSCRIPTIONS_ERROR",

    //AppVersion
    BUMPED_APP_VERSION = "BUMPED_APP_VERSION",

    //FcmTokens
    FCM_TOKEN_SUCCESS = "FCM_TOKEN_SUCCESS",
    FCM_TOKEN_NOT_SUPPORTED = "FCM_TOKEN_NOT_SUPPORTED",
    FCM_TOKEN_MISSING_ERROR = "FCM_TOKEN_MISSING_ERROR",
    FCM_GET_TOKEN_ERROR = "FCM_GET_TOKEN_ERROR",
    FCM_TOKEN_DENIED = "FCM_TOKEN_DENIED",
    FCM_TOKEN_GRANTED = "FCM_TOKEN_GRANTED",
    FCM_TOKEN_REQUESTED = "FCM_TOKEN_REQUESTED",

    //Login
    CREATED_APP_USER = "CREATED_APP_USER",
    UPDATED_APP_USER = "UPDATED_APP_USER",
    LOGGED_OUT = "LOGGED_OUT",
    SELECTED_ORG = "SELECTED_ORG",
    UNSELECTED_ORG = "UNSELECTED_ORG",

    //Org creation
    CREATED_ORG = "CREATED_ORG",
    CREATED_ORG_USER = "CREATED_ORG_USER",

    //Org management
    DELETED_ORG = "DELETED_ORG",
    UPDATED_ORG = "UPDATED_ORG",
    UPDATED_OWN_ORG = "UPDATED_OWN_ORG",
    TRANSFERED_ORG_OWNERSHIP = "TRANSFERED_ORG_OWNERSHIP",
    TRANSFER_ORG_OWNERSHIP_ERROR = "TRANSFER_ORG_OWNERSHIP_ERROR",

    //Price Field
    ADDED_CATEGORY_TO_PRICE_FIELD = "ADDED_CATEGORY_TO_PRICE_FIELD",
    REMOVED_CATEGORY_FROM_PRICE_FIELD = "REMOVED_CATEGORY_FROM_PRICE_FIELD",
    CREATED_PRICE_FIELD = "CREATED_PRICE_FIELD",
    IMPORTED_PRICE_FIELD_TEMPLATE = "IMPORTED_PRICE_FIELD_TEMPLATE",
    COPIED_PRICE_FIELD = "COPIED_PRICE_FIELD",
    UPDATED_PRICE_FIELD = "UPDATED_PRICE_FIELD",
    SUBSCRIBED_PRICE_FIELD_TO_TEMPLATE = "SUBSCRIBED_PRICE_FIELD_TO_TEMPLATE",
    REMOVED_PRICE_FIELD = "REMOVED_PRICE_FIELD",

    //Price Field Template
    ADDED_CATEGORY_TO_PRICE_FIELD_TEMPLATE = "ADDED_CATEGORY_TO_PRICE_FIELD_TEMPLATE",
    REMOVED_CATEGORY_FROM_PRICE_FIELD_TEMPLATE = "REMOVED_CATEGORY_FROM_PRICE_FIELD_TEMPLATE",
    CREATED_PRICE_FIELD_TEMPLATE = "CREATED_PRICE_FIELD_TEMPLATE",
    COPIED_PRICE_FIELD_TEMPLATE = "COPIED_PRICE_FIELD_TEMPLATE",
    UPDATED_PRICE_FIELD_TEMPLATE = "UPDATED_PRICE_FIELD_TEMPLATE",
    REMOVED_PRICE_FIELD_TEMPLATE = "REMOVED_PRICE_FIELD_TEMPLATE",

    //Price Field Template Suggestion
    ADDED_CATEGORY_TO_PRICE_FIELD_TEMPLATE_SUGGESTION = "ADDED_CATEGORY_TO_PRICE_FIELD_TEMPLATE_SUGGESTION",
    REMOVED_CATEGORY_FROM_PRICE_FIELD_TEMPLATE_SUGGESTION = "REMOVED_CATEGORY_FROM_PRICE_FIELD_TEMPLATE_SUGGESTION",
    CREATED_PRICE_FIELD_TEMPLATE_SUGGESTION = "CREATED_PRICE_FIELD_TEMPLATE_SUGGESTION",
    COPIED_PRICE_FIELD_TEMPLATE_SUGGESTION = "COPIED_PRICE_FIELD_TEMPLATE_SUGGESTION",
    UPDATED_PRICE_FIELD_TEMPLATE_SUGGESTION = "UPDATED_PRICE_FIELD_TEMPLATE_SUGGESTION",
    REMOVED_PRICE_FIELD_TEMPLATE_SUGGESTION = "REMOVED_PRICE_FIELD_TEMPLATE_SUGGESTION",

    //Price Field suggestion
    CREATED_PRICE_FIELD_SUGGESTION = "CREATED_PRICE_FIELD_SUGGESTION",
    CREATED_IMPORT_PRICE_FIELD_TEMPLATE_SUGGESTION = "CREATED_IMPORT_PRICE_FIELD_TEMPLATE_SUGGESTION",
    ACCEPTED_PRICE_FIELD_SUGGESTION = "ACCEPTED_PRICE_FIELD_SUGGESTION",
    REJECTED_PRICE_FIELD_SUGGESTION = "REJECTED_PRICE_FIELD_SUGGESTION",
    WITHDREW_PRICE_FIELD_SUGGESTION = "WITHDREW_PRICE_FIELD_SUGGESTION",
    DELETED_PRICE_FIELD_SUGGESTION = "DELETED_PRICE_FIELD_SUGGESTION",

    //Errors
    DELETE_HELP_CHAT_ERROR = "DELETE_HELP_CHAT_ERROR",
    DELETE_HELP_MESSAGE_ERROR = "DELETE_HELP_MESSAGE_ERROR",
    CREATE_HELP_MESSAGE_ATTACHMENT_ERROR = "CREATE_HELP_MESSAGE_ATTACHMENT_ERROR",
    CREATE_HELP_CHAT_ERROR = "CREATE_HELP_CHAT_ERROR",
    GET_HELP_CHAT_ERROR = "GET_HELP_CHAT_ERROR",
    GET_HELP_MESSAGES_ERROR = "GET_HELP_MESSAGES_ERROR",
    GET_HELP_CHATS_ERROR = "GET_HELP_CHATS_ERROR",
    SEND_HELP_MESSAGE_ERROR = "SEND_HELP_MESSAGE_ERROR",
    ADD_SESSION_URL_TO_HELP_MESSAGE_ERROR = "ADD_SESSION_URL_TO_HELP_MESSAGE_ERROR",
    GET_APP_RELEASE_VERSION_ERROR = "GET_APP_RELEASE_VERSION_ERROR",
    ERROR_BOUNDARY_ACTIVATION = "ERROR_BOUNDARY_ACTIVATION",
    SEND_OFFER_ERROR = "SEND_OFFER_ERROR",
    DOWNLOAD_OFFER_PDF_ERROR = "DOWNLOAD_OFFER_PDF_ERROR",
    CREATE_ORG_USER_ERROR = "CREATE_ORG_USER_ERROR",
    UPDATE_PRICE_FIELD_ERROR = "UPDATE_PRICE_FIELD_ERROR",
    SUBSCRIBE_PRICE_FIELD_TO_TEMPLATE_ERROR = "SUBSCRIBE_PRICE_FIELD_TO_TEMPLATE_ERROR",
    UPDATE_PRICE_FIELD_TEMPLATE_ERROR = "UPDATE_PRICE_FIELD_TEMPLATE_ERROR",
    UPDATE_PRICE_FIELD_TEMPLATE_SUGGESTION_ERROR = "UPDATE_PRICE_FIELD_TEMPLATE_SUGGESTION_ERROR",
    COPIED_PRICE_FIELD_ERROR = "COPIED_PRICE_FIELD_ERROR",
    COPIED_PRICE_FIELD_TEMPLATE_ERROR = "COPIED_PRICE_FIELD_TEMPLATE_ERROR",
    COPIED_PRICE_FIELD_TEMPLATE_SUGGESTION_ERROR = "COPIED_PRICE_FIELD_TEMPLATE_SUGGESTION_ERROR",
    CREATE_PRICE_FIELD_TEMPLATE_ERROR = "CREATE_PRICE_FIELD_TEMPLATE_ERROR",
    CREATE_PRICE_FIELD_TEMPLATE_SUGGESTION_ERROR = "CREATE_PRICE_FIELD_TEMPLATE_SUGGESTION_ERROR",
    CREATE_APP_USER_ERROR = "CREATE_APP_USER_ERROR",
    CREATE_ORG_ERROR = "CREATE_ORG_ERROR",
    GET_LATEST_OFFERS_ERROR = "GET_LATEST_OFFERS_ERROR",
    UPDATE_ORG_ERROR = "UPDATE_ORG_ERROR",
    UPDATE_OFFER_DRAFT_ERROR = "UPDATE_OFFER_DRAFT_ERROR",
    CREATE_OFFER_DRAFT_ERROR = "CREATE_OFFER_DRAFT_ERROR",
    DELETE_OFFER_DRAFTS_ERROR = "DELETE_OFFER_DRAFTS_ERROR",
    DELETE_OFFER_DRAFT_ERROR = "DELETE_OFFER_DRAFT_ERROR",
    DELETE_APP_USER_ERROR = "DELETE_APP_USER_ERROR",
    CREATE_OFFER_ERROR = "CREATE_OFFER_ERROR",
    DELETE_OFFER_ERROR = "DELETE_OFFER_ERROR",
    DELETE_OFFERS_ERROR = "DELETE_OFFERS_ERROR",
    UPDATE_OWN_ORG_USER_ERROR = "UPDATE_OWN_ORG_USER_ERROR",
    UPDATE_ORG_USER_ERROR = "UPDATE_ORG_USER_ERROR",
    GET_ORG_USER_INVITES_ERROR = "GET_ORG_USER_INVITES_ERROR",
    GET_ORG_USER_EMAIL_INVITES_ERROR = "GET_ORG_USER_EMAIL_INVITES_ERROR",
    GET_ORG_USERS_ERROR = "GET_ORG_USERS_ERROR",
    GET_OWN_ORG_USERS_ERROR = "GET_OWN_ORG_USERS_ERROR",
    GET_OWN_ORG_USER_ERROR = "GET_OWN_ORG_USER_ERROR",
    GET_STRIPE_PRODUCTS_ERROR = "GET_STRIPE_PRODUCTS_ERROR",
    GET_STRIPE_PRODUCT_PRICES_ERROR = "GET_STRIPE_PRODUCT_PRICES_ERROR",
    GET_ORGS_ERROR = "GET_ORGS_ERROR",
    GET_ORG_ERROR = "GET_ORG_ERROR",
    GET_PRICE_FIELDS_ERROR = "GET_PRICE_FIELDS_ERROR",
    GET_PRICE_FIELD_TEMPLATES_ERROR = "GET_PRICE_FIELD_TEMPLATES_ERROR",
    GET_PRICE_FIELD_TEMPLATE_ERROR = "GET_PRICE_FIELD_TEMPLATE_ERROR",
    GET_PRICE_FIELD_TEMPLATE_SUGGESTIONS_ERROR = "GET_PRICE_FIELD_TEMPLATE_SUGGESTIONS_ERROR",
    GET_PRICE_FIELD_TEMPLATE_SUGGESTION_ERROR = "GET_PRICE_FIELD_TEMPLATE_SUGGESTION_ERROR",
    GET_PRICE_FIELD_ERROR = "GET_PRICE_FIELD_ERROR",
    GET_OFFER_DRAFTS_ERROR = "GET_OFFER_DRAFTS_ERROR",
    GET_OFFER_DRAFT_ERROR = "GET_OFFER_DRAFT_ERROR",
    GET_OFFER_ERROR = "GET_OFFER_ERROR",
    GET_APP_USER_ERROR = "GET_APP_USER_ERROR",
    GET_APP_USERS_ERROR = "GET_APP_USERS_ERROR",
    CREATE_PRICE_FIELD_ERROR = "CREATE_PRICE_FIELD_ERROR",
    CREATE_PRICE_FIELD_SUGGESTION_ERROR = "CREATE_PRICE_FIELD_SUGGESTION_ERROR",
    GET_PRICE_FIELD_SUGGESTION_ERROR = "GET_PRICE_FIELD_SUGGESTION_ERROR",
    GET_PRICE_FIELD_SUGGESTIONS_ERROR = "GET_PRICE_FIELD_SUGGESTIONS_ERROR",
    UPDATE_APP_USER_ERROR = "UPDATE_APP_USER_ERROR",
    UPDATE_APP_ROLE_ERROR = "UPDATE_APP_ROLE_ERROR",
    ACCEPT_PRICE_FIELD_SUGGESTION_ERROR = "ACCEPT_PRICE_FIELD_SUGGESTION_ERROR",
    REJECT_PRICE_FIELD_SUGGESTION_ERROR = "REJECT_PRICE_FIELD_SUGGESTION_ERROR",
    DELETE_PRICE_FIELD_SUGGESTION_ERROR = "DELETE_PRICE_FIELD_SUGGESTION_ERROR",
    DELETE_PRICE_FIELD_TEMPLATE_ERROR = "DELETE_PRICE_FIELD_TEMPLATE_ERROR",
    DELETE_PRICE_FIELD_TEMPLATE_SUGGESTION_ERROR = "DELETE_PRICE_FIELD_TEMPLATE_SUGGESTION_ERROR",
    DELETE_PRICE_FIELD_ERROR = "DELETE_PRICE_FIELD_ERROR",
    CREATE_ORG_INVITE_ERROR = "CREATE_ORG_INVITE_ERROR",
    WITHDRAW_ORG_INVITE_ERROR = "WITHDRAW_ORG_INVITE_ERROR",
    ADDRESS_ORG_INVITE_ERROR = "ADDRESS_ORG_INVITE_ERROR",
    CREATE_ORG_EMAIL_INVITE_ERROR = "CREATE_ORG_EMAIL_INVITE_ERROR",
    WITHDRAW_ORG_EMAIL_INVITE_ERROR = "WITHDRAW_ORG_EMAIL_INVITE_ERROR",
    ADDRESS_ORG_EMAIL_INVITE_ERROR = "ADDRESS_ORG_EMAIL_INVITE_ERROR",
    FETCH_ORG_USER = "FETCH_ORG_USER",
    FETCH_ORG_USER_ERROR = "FETCH_ORG_USER_ERROR",
    FETCH_ORG_ERROR = "FETCH_ORG_ERROR",
    DISMISSED_OFFERS_ERROR = "DISMISSED_OFFERS_ERROR",
    DISMISSED_OFFER_DRAFTS_ERROR = "DISMISSED_OFFER_DRAFTS_ERROR",
    DELETE_ORG_USER_ERROR = "DELETE_ORG_USER_ERROR",
    DELETE_ORG_ERROR = "DELETE_ORG_ERROR",

    //Install
    CLICKED_INSTALL_BUTTON = "CLICKED_INSTALL_BUTTON",
    ACCEPTED_INSTALL_DIALOG = "ACCEPTED_INSTALL_DIALOG",
    DECLINED_INSTALL_DIALOG = "DECLINED_INSTALL_DIALOG",

    //Org users
    DELETED_ORG_USER = "DELETED_ORG_USER",
    UPDATED_ORG_USER = "UPDATED_ORG_USER",
    UPDATED_OWN_ORG_USER = "UPDATED_OWN_ORG_USER",
    DELETED_OWN_ORG_USER = "DELETED_OWN_ORG_USER",

    //App users
    PREPARING_TO_DELETE_APP_USER = "PREPARING_TO_DELETE_APP_USER",
    DELETED_APP_USER = "DELETED_APP_USER",
    DELETED_OWN_APP_USER = "DELETED_OWN_APP_USER",
    UPDATED_OWN_APP_USER = "UPDATED_OWN_APP_USER",

    //Org invites
    CREATED_ORG_INVITE = "CREATED_ORG_INVITE",
    ADDRESSED_ORG_INVITE = "ADDRESSED_ORG_INVITE",
    WITHDREW_ORG_INVITE = "WITHDREW_ORG_INVITE",
    ACCEPTED_ORG_INVITE = "ACCEPTED_ORG_INVITE",
    REJECTED_ORG_INVITE = "REJECTED_ORG_INVITE",

    //Org email invites
    CREATED_ORG_EMAIL_INVITE = "CREATED_ORG_EMAIL_INVITE",
    ADDRESSED_ORG_EMAIL_INVITE = "ADDRESSED_ORG_EMAIL_INVITE",
    WITHDREW_ORG_EMAIL_INVITE = "WITHDREW_ORG_EMAIL_INVITE",
    ACCEPTED_ORG_EMAIL_INVITE = "ACCEPTED_ORG_EMAIL_INVITE",
    REJECTED_ORG_EMAIL_INVITE = "REJECTED_ORG_EMAIL_INVITE",

    //Org roles
    ADDED_ORG_ROLE = "ADDED_ORG_ROLE",
    REMOVED_ORG_ROLE = "REMOVED_ORG_ROLE",
    ADDED_OWN_ORG_ROLE = "ADDED_OWN_ORG_ROLE",
    REMOVED_OWN_ORG_ROLE = "REMOVED_OWN_ORG_ROLE",

    //App roles
    ADDED_APP_ROLE = "ADDED_APP_ROLE",
    REMOVED_APP_ROLE = "REMOVED_APP_ROLE",
    ADDED_OWN_APP_ROLE = "ADDED_OWN_APP_ROLE",
    REMOVED_OWN_APP_ROLE = "REMOVED_OWN_APP_ROLE",

    //Offer
    CREATED_OFFER = "CREATED_OFFER",
    DELETED_OFFER = "DELETED_OFFER",
    DELETED_OFFERS = "DELETED_OFFERS",
    SENT_OFFER = "SENT_OFFER",
    COPIED_OFFER = "COPIED_OFFER",
    DOWNLOADED_OFFER_PDF = "DOWNLOADED_OFFER_PDF",
    VIEWED_OFFER_PDF = "VIEWED_OFFER_PDF",

    //Offer drafts
    CREATED_OFFER_DRAFT = "CREATED_OFFER_DRAFT",
    UPDATED_OFFER_DRAFT = "UPDATED_OFFER_DRAFT",
    DELETED_OFFER_DRAFT = "DELETED_OFFER_DRAFT",
    DELETED_OFFER_DRAFTS = "DELETED_OFFER_DRAFT",

    //MissingProfiles
    MISSING_ORG = "MISSING_ORG",
    MISSING_ORG_USER = "MISSING_ORG_USER",
    MISSING_APP_USER = "MISSING_APP_USER",
    MISSING_AUTH_USER = "MISSING_AUTH_USER",
}
